import 'GIS/Data/Layers'
import 'Spatial/Data/Classes'
import './SpatialObjects'

/** @namespace Spatial.Data */
NS("Accounting.Data");

/**
 * Spatial.Data.Classes source
 * @class
 * @extends Spatial.Data.Classes
 */
Accounting.Data.SpatialClasses = Class(Spatial.Data.Classes, /** @lends Spatial.Data.Classes.prototype */{
    url: "Accounting/Web/SpatialClasses/",

    /**
     * @param {Object} item
     * @returns {{class: *, options: *}}
     * @throws InvalidArgumentError
     */
    toLayerOptions(item) {
        assert(_.isObject(item) && !_.isEmpty(item) && !_.isEmpty(item.layer), "invalid or empty item", InvalidArgumentError);

        const useCluster = GIS.Geometry.simpleName(item.geomtype) === 'point';

        item = {
            ds: new Accounting.Data.SpatialObjects(),
            dsMethod: 'findForMap',
            clusterDistance: useCluster ? 40 : undefined,
            asImage: true,
            // dataGeometryNameMap: {
            //     10: 'geog2',
            //     13: 'geog1'
            // },
            ...item.layer,
            ...item
        };

        return new GIS.Data.Layers().toLayerOptions(item);
    }
});
